import React from 'react';
import {ButtonPriority, SectionNotification, SectionNotificationType} from 'wix-ui-tpa';
import {classes} from './CalculateCartErrorNotification.st.css';
import {TotalsSectionDataHooks} from '../TotalsSection';
import {Error} from '@wix/wix-ui-icons-common/on-stage';
import {Refresh} from '@wix/wix-ui-icons-common';
import {useControllerProps} from '../../../Widget/ControllerContext';
import {useLocaleKeys} from '../../../../../locale-keys/LocaleKeys';

export const CalculateCartErrorNotification = () => {
  const {refetchCartSummary} = useControllerProps().checkoutStore;
  const localeKeys = useLocaleKeys();

  return (
    <SectionNotification
      className={classes.notification}
      type={SectionNotificationType.error}
      data-hook={TotalsSectionDataHooks.CalculateCartErrorNotification}>
      <SectionNotification.Icon icon={<Error className={classes.errorIcon} />} />
      <SectionNotification.Text>{localeKeys.checkout.totalsFail.error.message()}</SectionNotification.Text>
      <SectionNotification.Button
        key="secondary"
        priority={ButtonPriority.basicSecondary}
        onClick={() => {
          void refetchCartSummary();
        }}>
        <div className={classes.buttonContent}>
          <SectionNotification.Icon icon={<Refresh className={classes.refreshIcon} />} />
          {localeKeys.checkout.totalsFail.error.refresh()}
        </div>
      </SectionNotification.Button>
    </SectionNotification>
  );
};
